// A gym's web address (its organization's slug, chosen at signup; backend/services/gym_address.py has the rules).
// On a brand with a tenantDomain (brands.json) each gym is served at https://<address>.<tenantDomain>/; every
// deployment also keeps /org/<address>/login, which works on any host (e.g. a white-label gym's own domain).
import { brand } from "../brand";

// Hosts the app itself is served on under the tenant domain: never a gym (the backend reserves them too).
const APP_LABELS = new Set(["app", "www"]);
const ADDRESS = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

// The domains whose subdomains are gyms: the brand's, and in development <gym>.localhost (browsers resolve it locally).
const gymDomains = () =>
  [brand.tenantDomain, process.env.NODE_ENV === "development" && "localhost"].filter(Boolean);

// The gym whose subdomain this page was opened on, or null on any other host.
export function gymFromHost(hostname = window.location.hostname, domains = gymDomains()) {
  for (const domain of domains) {
    const suffix = `.${domain}`;
    if (hostname.endsWith(suffix)) {
      const label = hostname.slice(0, -suffix.length);
      if (ADDRESS.test(label) && !APP_LABELS.has(label)) return label;
    }
  }
  return null;
}

// Where a gym's staff and members sign in: its subdomain, or its /org/ page on this host.
export function gymLoginUrl(address, tenantDomain = brand.tenantDomain, origin = window.location.origin) {
  return tenantDomain ? `https://${address}.${tenantDomain}/` : `${origin}/org/${address}/login`;
}
